import { useEffect, useRef } from "react";
import { Wrapper, ContentTypeRender, useLocation } from "nystem-components";

const TravelsSection = ({ model, path }) => {
  const ref = useRef();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === `#${model.anchor}`) ref.current.scrollIntoView();
  }, [hash, model.anchor]);

  return <Wrapper ref={ref} id={model.anchor} renderAs="section" className={model.className}><ContentTypeRender path={path} items={model.item} /></Wrapper>;
};

export default TravelsSection;
